module.exports = "/fonts/vendor/@fontsource/roboto/files/roboto-greek-700-normal.woff2?50e795c1345353b0e99611abfba3ea82";